import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateCustomer } from '../hooks/useCustomers';
import Button from '../components/Button';
import Input from '../components/Input';
import Card from '../components/Card';

export default function NewCustomer() {
  const navigate = useNavigate();
  const createCustomer = useCreateCustomer();

  const [formData, setFormData] = useState({
    customer: '',
    customer_location: '',
  });

  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrors({});

    if (!formData.customer.trim()) {
      setErrors({ customer: 'Customer name is required' });
      return;
    }

    try {
      await createCustomer.mutateAsync({
        customer: formData.customer.trim(),
        customer_location: formData.customer_location.trim() || undefined,
      });
      navigate('/customers');
    } catch (error) {
      setErrors({ submit: 'Failed to create client. Please try again.' });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4 mb-4">
        <button
          onClick={() => navigate('/customers')}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Back to clients"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div className="flex-1">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            New Customer
          </h1>
          <p className="text-base md:text-lg text-gray-600">
            Add a new customer to the system
          </p>
        </div>
      </div>

      <Card>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Input
            label="Customer Name *"
            value={formData.customer}
            onChange={(e) => setFormData({ ...formData, customer: e.target.value })}
            error={errors.customer}
            placeholder="e.g., ABC Corporation"
            required
          />

          <Input
            label="Customer Location"
            value={formData.customer_location}
            onChange={(e) => setFormData({ ...formData, customer_location: e.target.value })}
            placeholder="e.g., New York, USA"
          />

          {errors.submit && (
            <div className="bg-red-50 border-l-4 border-red-500 rounded-xl p-4">
              <p className="text-sm text-red-700">{errors.submit}</p>
            </div>
          )}

          <div className="flex gap-4">
            <Button
              type="submit"
              variant="primary"
              disabled={createCustomer.isPending}
            >
              {createCustomer.isPending ? 'Creating...' : 'Create Customer'}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}


